class LocalCache {
  // isLocal = true
  // constructor(isLocal = true) {
  //   this.isLocal = isLocal
  // }
  setCache(key, value, isLocal = true) {
    isLocal ? localStorage.setItem(key, JSON.stringify(value)) : sessionStorage.setItem(key, JSON.stringify(value))
  }
  getCache(key, isLocal = true) {
    const value = isLocal ? localStorage.getItem(key) : sessionStorage.getItem(key)
    if (value) {
      return JSON.parse(value)
    }
  }

  removeCache(key, isLocal = true) {
    isLocal ? localStorage.removeItem(key) : sessionStorage.removeItem(key)
  }

  clear(isLocal = true) {
    isLocal ? localStorage.clear() : sessionStorage.clear()
  }
}

export default new LocalCache()
